<div fxLayout="column" fxHide.lt-md>
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else paymentAmountFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="paymentAmountFlexColumnTemplate"></ng-container>
    </div>
</div>

<div fxLayout="column" fxHide.gt-sm ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <ng-container *ngTemplateOutlet="paymentAmountNoteListCardViewTemplate"></ng-container>
</div>

<ng-template #paymentAmountNoteListCardViewTemplate>

    <div fxLayout="column">

        <ng-container *ngFor="let row of openNotesPaymentInfoListWithFooters">
            <ng-container *ngIf="row.hasOwnProperty('isGroupFooter')">
                <mat-card style="background-color: #e3f2fd;">
                    <mat-card-content>
                        <div style="display: flex; justify-content: space-between;">
                            <mat-label><span class="header-superscript header-after-content-3"
                                    [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                    i18n="@@payment-note-list.table.column-header.total-amount-due">payment-note-list.table.column-header.total-amount-due</span></mat-label>
                            <span style="text-align: right;">{{
                                row.totalAmountDueTotal | currency
                                }}</span>
                        </div>
                    </mat-card-content>
                </mat-card>
            </ng-container>
            <ng-container *ngIf="!row.hasOwnProperty('isGroupFooter')">
                <mat-card *ngIf="row.noteId">
                    <mat-card-content>
                        <div style="width: 100%;">
                            <!-- Left Section: Note ID and Note Status -->
                            <div>
                                <mat-card-title>{{ row.noteId }}
                                    <!-- <a class="tooltip-link" (click)="openToolTip('noteId')"
                                        style="display: inline-flex; align-items: center; vertical-align: middle;">
                                        <mat-icon class="tooltip-icon-link"
                                            style="font-size: 16px; vertical-align: middle; margin-left: 4px;"
                                            matTooltip="{{ getToolTip('noteId') }}" matTooltipPosition="after"
                                            matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                                    </a> -->
                                </mat-card-title>
                                <mat-card-subtitle>{{ row.noteStatus }}
                                    <!-- <a class="tooltip-link" (click)="openToolTip('noteStatus')"
                                        style="display: inline-flex; align-items: center; vertical-align: middle;">
                                        <mat-icon class="tooltip-icon-link"
                                            style="font-size: 16px; vertical-align: middle; margin-left: 4px;"
                                            matTooltip="{{ getToolTip('noteStatus') }}" matTooltipPosition="after"
                                            matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                                    </a> -->
                                </mat-card-subtitle>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-amount.table.column-header.next-payment-due-date">payment-amount.table.column-header.next-payment-due-date</span></mat-label>
                                    <span style="text-align: right;">{{ row.nextPaymentDueDate }}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span class="header-superscript header-after-content-2"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-amount.table.column-header.past-due-amount">payment-amount.table.column-header.past-due-amount</span></mat-label>
                                    <span style="text-align: right;">{{ row.pastDueAmount | currency }}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span class="header-superscript header-after-content-1"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-amount.table.column-header.late-fee-due">payment-amount.table.column-header.late-fee-due</span></mat-label>
                                    <span style="text-align: right;">{{ row.lateFeeDue | currency}}</span>
                                </div>
                                <div *ngIf="row.regularPaymentAmount > 0"
                                    style="display: flex; justify-content: space-between;">
                                    <mat-label> <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-amount.table.column-header.regular-payment-amount">payment-amount.table.column-header.regular-payment-amount</span></mat-label>
                                    <span style="text-align: right;">{{ row.regularPaymentAmount | currency}}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span class="header-superscript header-after-content-3"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-amount.table.column-header.total-amount-due">payment-amount.table.column-header.total-amount-due</span></mat-label>
                                    <span style="text-align: right;">{{ row.totalAmountDue | currency }}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span class="header-superscript header-after-content-4"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-amount.table.column-header.payoff-amount">payment-amount.table.column-header.payoff-amount</span></mat-label>
                                    <span style="text-align: right;">{{ row.payoffAmount | currency }}</span>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </ng-container>
        </ng-container>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="paymentSelectedDataFound">
        <div *ngIf="isBrowserIE; else paymentAmountPostTableFlexColumnTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentAmountPostTableFlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #paymentAmountFlexColumnTemplate>
    <div fxLayout="column">
        <div *ngIf="isBrowserIE; else paymentAmountTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentAmountTableFlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #paymentAmountTableFlexColumnTemplate>
    <div fxFlex="100%" class="display-text primary-dark-color-important" *ngIf="displayTitle">
        <b><span i18n="@@payment-amount.table.title">payment-amount.table.title</span></b>
    </div>

    <div fxFlex="100%" class="display-text title-spacer" *ngIf="!paymentSelectedDataFound">
        <i><span i18n="@@payment-amount.table.no-records">payment-amount.table.no-records</span></i>
    </div>

    <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }">
        <mat-table #table [dataSource]="tableDataSource" ngClass.lt-md="small-table-text">
            <!-- noteId Column -->
            <ng-container matColumnDef="noteId">
                <mat-header-cell *matHeaderCellDef fxFlex="11%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-amount.table.column-header.note-id">payment-amount.table.column-header.note-id</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.noteId
                    }}</mat-cell>
            </ng-container>
            <!-- nextPaymentDueDate Column -->
            <ng-container matColumnDef="nextPaymentDueDate">
                <mat-header-cell *matHeaderCellDef fxFlex="11%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-amount.table.column-header.next-payment-due-date">payment-amount.table.column-header.next-payment-due-date</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.nextPaymentDueDate
                    }}</mat-cell>
            </ng-container>
            <!-- noteDate Column -->
            <ng-container matColumnDef="noteDate">
                <mat-header-cell *matHeaderCellDef fxFlex="11%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-amount.table.column-header.note-date">payment-amount.table.column-header.note-date</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.noteDate
                    }}</mat-cell>
            </ng-container>
            <!-- noteStatus Column -->
            <ng-container matColumnDef="noteStatus">
                <mat-header-cell *matHeaderCellDef fxFlex="12%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-amount.table.column-header.note-status">payment-amount.table.column-header.note-status</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.noteStatus
                    }}</mat-cell>
            </ng-container>
            <!-- pastDueAmount Column -->
            <ng-container matColumnDef="pastDueAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="11%">
                    <span class="header-superscript header-after-content-2"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-amount.table.column-header.past-due-amount">payment-amount.table.column-header.past-due-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.pastDueAmount | currency
                    }}</mat-cell>
            </ng-container>
            <!-- lateFeeDue Column -->
            <ng-container matColumnDef="lateFeeDue">
                <mat-header-cell *matHeaderCellDef fxFlex="11%">
                    <span class="header-superscript header-after-content-1"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-amount.table.column-header.late-fee-due">payment-amount.table.column-header.late-fee-due</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.lateFeeDue | currency
                    }}</mat-cell>
            </ng-container>
            <!-- regularPaymentAmount Column -->
            <ng-container matColumnDef="regularPaymentAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="11%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-amount.table.column-header.regular-payment-amount">payment-amount.table.column-header.regular-payment-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.regularPaymentAmount | currency
                    }}</mat-cell>
            </ng-container>
            <!-- totalAmountDue Column -->
            <ng-container matColumnDef="totalAmountDue">
                <mat-header-cell *matHeaderCellDef fxFlex="11%">
                    <span class="header-superscript header-after-content-3"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-amount.table.column-header.total-amount-due">payment-amount.table.column-header.total-amount-due</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.totalAmountDue | currency
                    }}</mat-cell>
            </ng-container>
            <!-- payoffAmount Column -->
            <ng-container matColumnDef="payoffAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="11%">
                    <span class="header-superscript header-after-content-4"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-amount.table.column-header.payoff-amount">payment-amount.table.column-header.payoff-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="11%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.payoffAmount | currency
                    }}</mat-cell>
            </ng-container>

            <!-- Group Footer -->
            <ng-container matColumnDef="groupFooterTotals">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }"
                    style="padding-right: 20px; text-align: right;" mat-cell *matCellDef="let groupFooter" fxFlex="45%"
                    fxLayoutAlign="end center">
                    <strong><span
                            i18n="@@payment-amount.table.group-footer.pay-group">payment-amount.table.group-footer.pay-group</span>:</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterPastDueAmountTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="11%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.pastDueAmountTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterLateFeeDueTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="11%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.lateFeeDueTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterRegularPaymentAmountTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="11%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.regularPaymentAmountTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterTotalAmountDueTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="11%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.totalAmountDueTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterPayoffAmountTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="11%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.payoffAmountTotal | currency }}</strong>
                </td>
            </ng-container>
            <tr mat-row class="mat-row-group-footer" *matRowDef="
          let row;
          columns: [
            'groupFooterTotals',
            'groupFooterPastDueAmountTotal',
            'groupFooterLateFeeDueTotal',
            'groupFooterRegularPaymentAmountTotal',
            'groupFooterTotalAmountDueTotal',
            'groupFooterPayoffAmountTotal'
          ];
          when: isGroupFooter
        "></tr>

            <mat-header-row class="primary-light-bg-top-to-bottom-gradient" *matHeaderRowDef="tableDisplayedColumns"
                ngClass.lt-md="small-header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"></mat-row>
        </mat-table>

        <div fxLayoutAlign="end center" class="small-display-text primary-light-color" *ngIf="paymentSelectedDataFound">
            <app-table-record-count [recordCount]="recordCount"
                i18n-singularLabel="@@payment-amount.table.record-count.singular-label"
                singularLabel="payment-amount.table.record-count.singular-label"
                i18n-multipleLabel="@@payment-amount.table.record-count.multiple-label"
                multipleLabel="payment-amount.table.record-count.multiple-label"></app-table-record-count>
        </div>
        <div fxLayout="column" style="margin-top: 16px" *ngIf="paymentSelectedDataFound">
            <div *ngIf="isBrowserIE; else paymentAmountPostTableFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="paymentAmountPostTableFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #paymentAmountPostTableFlexColumnTemplate>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px" *ngIf="paymentSelectedDataFound">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentAmountFormFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="paymentAmountFormFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px" style="margin-top: 16px"
        *ngIf="paymentSelectedDataFound">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentAmountOptionsFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="paymentAmountOptionsFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="paymentSelectedDataFound && displayNotices">
        <div *ngIf="isBrowserIE; else paymentAmountNoticesFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentAmountNoticesFlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #paymentAmountFormFlexColumnTemplate>
    <div fxFlex="100%" fxLayoutAlign="center center">
        <form [formGroup]="paymentAmountForm">
            <mat-radio-group class="form-radio-group display-text" [formControl]="selectedPaymentOption">
                <mat-radio-button class="form-radio-button" value="TOTAL" (click)="onRadioButtonClick('TOTAL')">
                    <mat-form-field>
                        <input matInput i18n-placeholder="@@payment-amount.form.total-amount-due.label"
                            placeholder="payment-amount.form.total-amount-due.label" type="text"
                            [value]="totalAmountDueValueString" autocomplete="off" readonly />
                        <span matPrefix>$&nbsp;</span>
                    </mat-form-field>
                </mat-radio-button>
                <mat-radio-button class="form-radio-button" value="CUSTOM" (click)="onRadioButtonClick('CUSTOM')">
                    <mat-form-field>
                        <input matInput i18n-placeholder="@@payment-amount.form.custom-payment-amount.label"
                            placeholder="payment-amount.form.custom-payment-amount.label" type="number"
                            [formControl]="customPaymentAmount" autocomplete="off"
                            onkeypress="return isNumberKey(this, event, 2)" />
                        <span matPrefix>$&nbsp;
                        </span>
                        <mat-hint align="end">{{ minimumAmountDueValue | currency }} - {{ maximumAmountDueValue |
                            currency }}
                            <span class="radio-superscript header-after-content-5" *ngIf="CompanyCode_Check()"></span>
                        </mat-hint>
                        <mat-error class="form-error" *ngIf="customPaymentAmount.hasError('required')"
                            i18n="@@payment-amount.form.custom-payment-amount.error.required">payment-amount.form.custom-payment-amount.error.required</mat-error>
                        <mat-error class="form-error"
                            *ngIf="customPaymentAmount.hasError('min') && !customPaymentAmount.hasError('required')">
                            <span
                                i18n="@@payment-amount.form.custom-payment-amount.error.min">payment-amount.form.custom-payment-amount.error.min</span>
                            {{ minimumAmountDueValue | currency }}</mat-error>
                        <mat-error class="form-error"
                            *ngIf="customPaymentAmount.hasError('max') && !customPaymentAmount.hasError('required')">
                            <span
                                i18n="@@payment-amount.form.custom-payment-amount.error.max">payment-amount.form.custom-payment-amount.error.max</span>
                            {{ maximumAmountDueValue | currency }}</mat-error>
                    </mat-form-field>
                </mat-radio-button>
            </mat-radio-group>
        </form>
    </div>
</ng-template>

<ng-template #paymentAmountOptionsFlexColumnTemplate>
    <div fxFlex="100%" class="display-text" fxLayoutAlign="center center">
        <button mat-flat-button color="primary" (click)="setPaymentAmount()" [disabled]="!paymentAmountForm.valid"
            i18n="@@payment-amount.form.set-button.label">
            payment-amount.form.set-button.label
        </button>
    </div>
</ng-template>

<ng-template #paymentAmountNoticesFlexColumnTemplate>
    <div fxFlex="100%" class="display-text"><sup>1</sup>&nbsp;<span
            i18n="@@payment-amount.notices.1">payment-amount.notices.1</span></div>
    <div fxFlex="100%" class="display-text"><sup>2</sup>&nbsp;<span
            i18n="@@payment-amount.notices.2">payment-amount.notices.2</span></div>
    <div fxFlex="100%" class="display-text"><sup>3</sup>&nbsp;<span
            i18n="@@payment-amount.notices.3">payment-amount.notices.3</span></div>
    <div fxFlex="100%" class="display-text">
        <sup>4</sup>&nbsp;<span i18n="@@payment-amount.notices.4a">payment-amount.notices.4a</span>&nbsp;<b><span
                i18n="@@payment-amount.notices.4b">payment-amount.notices.4b</span></b>&nbsp;<span
            i18n="@@payment-amount.notices.4c">payment-amount.notices.4c</span>
    </div>
    <div fxFlex="100%" class="display-text" *ngIf="CompanyCode_Check()">
        <sup>5</sup>&nbsp;<b><span i18n="@@payment-amount.notices.5a">payment-amount.notices.5a</span>&nbsp;
            <a target="_blank" href="https://www.tuitionoptions.com/about-payments">
                <span i18n="@@payment-amount.notices.5b">payment-amount.notices.5b</span>
            </a>&nbsp;
            <span i18n="@@payment-amount.notices.5c">payment-amount.notices.5c</span>
        </b>
    </div>
    <div fxFlex="100%" class="display-text"><sup>*</sup>&nbsp;<span
            i18n="@@payment-amount.notices.6">payment-amount.notices.6</span></div>
</ng-template>
